import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useEventListener } from 'src/core/hooks/useEventListener';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { Language } from 'src/shared/constants/languages';
import { DateHelper } from 'src/shared/helpers/date';
import { useL10n } from './useL10n';
import { useLocaleFile } from './useLocaleFile';
import '@hotmart-org-ca/cosmos/dist/date-picker';
const DateFormat = {
    [Language.Es]: 'DD/MM/YYYY',
    [Language.Fr]: 'DD/MM/YYYY',
    [Language.En]: 'MM/DD/YYYY',
    [Language.PtBr]: 'DD/MM/YYYY'
};
export function DatePicker({ onChange, onOpen, onClose, valid, invalid, disabled, date, placeholder }) {
    const { l10n } = useL10n();
    const { language } = useHostContext();
    const { getLocaleFile } = useLocaleFile(language);
    const datePickerRef = useRef(null);
    function handleOpen() {
        onOpen?.();
    }
    function handleClose() {
        onClose?.();
    }
    function handleChange(event) {
        const detail = event.detail;
        onChange(detail);
    }
    useEventListener('change', handleChange, datePickerRef.current);
    useEventListener('open', handleOpen, datePickerRef.current);
    useEventListener('close', handleClose, datePickerRef.current);
    useEffect(function effectChangeLanguage() {
        async function changeLanguage() {
            const localeFile = await getLocaleFile();
            datePickerRef.current?.setLocale(localeFile, l10n);
        }
        changeLanguage();
    }, [getLocaleFile, l10n]);
    return (_jsx("hot-date-picker", { valid: valid, invalid: invalid, disabled: disabled, ref: datePickerRef, placeholder: placeholder, "date-format": DateFormat[language], ...(date && {
            date: DateHelper.formatIsoString(date.toISOString(), { dateStyle: 'short' })
        }) }));
}
